import { TextField } from "@roc/ui";
import { ICellEditor, ICellEditorParams } from "ag-grid-community";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { usePayablesDashboardStore } from "../../hooks/usePayablesDashboardStore";
import { PayableReceivablesTypes } from "../../types/types";

const useStyles = makeStyles((theme: Theme) => ({
  selectField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
      height: '40px',
    },
  },
}));
interface ExtendedEditorParams extends ICellEditorParams {
  type?: string;
}

export const AdjustmentEditor = forwardRef<ICellEditor, ExtendedEditorParams>((props, ref) => {
  const { value, type } = props;
  const { payablesApprovedStore } = usePayablesDashboardStore();
  const [editableValue, setEditableValue] = useState(value);
  const [prevEditableValue, setPrevEditableValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return editableValue;
    },
  }));

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
    setPrevEditableValue(value);
  }, []);

  return (
    <TextField
      disabled={props?.data?.feeType === "Credit Memo"
        || (props?.data?.status != PayableReceivablesTypes.PENDING && props?.data?.status != PayableReceivablesTypes.APPROVED)}
      type="number"
      fullWidth
      testId="invoice"
      variant="outlined"
      standaloneLabel
      value={editableValue}
      onChange={e => {
        const value = e.target.value;
        setEditableValue(value || '');
      }}
      onBlur={async () => {
        if (editableValue && editableValue !== prevEditableValue) {
          await payablesApprovedStore.updatePayableAdjustment(props?.data?.recordId, editableValue, null);
          payablesApprovedStore.counterPartyExpenseGridStore.refresh();
        }
      }}
      className={classes.selectField}
    />
  );
});
